/**
 * ERPCA client portal — form POSTs to their server.
 * Override via REACT_APP_ERPCA_LOGIN_URL / REACT_APP_ERPCA_API_KEY in .env
 */
export const CLIENT_PORTAL_PATH = '/client-portal';
/** Hash target for HashScrollHandler when opening Login from the header. */
export const CLIENT_PORTAL_LOGIN_HASH = 'client-portal-login';
export const CLIENT_PORTAL_HREF = `${CLIENT_PORTAL_PATH}#${CLIENT_PORTAL_LOGIN_HASH}`;

/** Header link + ErpcaLoginForm submit — keep in sync visually. */
export const CLIENT_PORTAL_CTA_CLASSNAME =
  'group inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-[#1e3a8a] to-[#2563eb] text-base font-semibold text-white shadow-md transition hover:from-[#1e40af] hover:to-[#3b82f6] hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1e3a8a]/40 focus-visible:ring-offset-2';

export const ERPCA_LOGIN_ACTION =
  (process.env.REACT_APP_ERPCA_LOGIN_URL || '').trim();

export const ERPCA_API_KEY =
  (process.env.REACT_APP_ERPCA_API_KEY || '').trim();
